import { get } from '../API';
import { PING } from '../paths';

// eslint-disable-next-line import/prefer-default-export
export function getPing() {
    return get(PING);
}
